/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_HeadingInputs */

const tr_servis_s5_heading = /** @type {(inputs: Servis_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Askıya Alma ve Hesap Kısıtlama`)
};

const en_servis_s5_heading = /** @type {(inputs: Servis_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Suspension and Account Restriction`)
};

const de_servis_s5_heading = /** @type {(inputs: Servis_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Sperrung und Einschränkung des Kontos`)
};

const ru_servis_s5_heading = /** @type {(inputs: Servis_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Приостановка и ограничение учетной записи`)
};

/**
* | output |
* | --- |
* | "5. Suspension and Account Restriction" |
*
* @param {Servis_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_heading = /** @type {((inputs?: Servis_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_heading(inputs)
	if (locale === "de") return de_servis_s5_heading(inputs)
	if (locale === "ru") return ru_servis_s5_heading(inputs)
	return tr_servis_s5_heading(inputs)
});